module.exports = __webpack_public_path__ + "static/media/knob_big_128.eb02f362.png";